import { render, staticRenderFns } from "./accountAdd.vue?vue&type=template&id=0485f431&scoped=true&"
import script from "./accountAdd.vue?vue&type=script&lang=js&"
export * from "./accountAdd.vue?vue&type=script&lang=js&"
import style0 from "./accountAdd.vue?vue&type=style&index=0&id=0485f431&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485f431",
  null
  
)

export default component.exports